var _rect, _style, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Share_Video",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Icon-bckgrd",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    fill: "none",
    stroke: "none"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    * { stroke-width: 0px; }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_100",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_298",
    d: "M15.36905,6.6078l3.8,3.7,1-1-5.5-5.5-5.5,5.5,1,1,3.8-3.7v14.2h1.4V6.6078Z",
    strokeWidth: 0,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_302",
    d: "M25.46505,10.8078H4.17305c-1.04729-.04944-1.93923.75331-2,1.8v14.4c.06077,1.04669.95271,1.84944,2,1.8h20.992c1.04729.04944,1.93923-.75331,2-1.8v-14.4c.02358-.96496-.73527-1.76844-1.7-1.8ZM17.66505,11.7078h4v1.8h-4v-1.8ZM12.66505,11.7078h4v1.8h-3.992l-.008-1.8ZM7.66505,11.7078h4v1.8h-3.992l-.008-1.8ZM3.16505,12.6078c-.00308-.49705.39736-.90248.89441-.90556.03528-.00022.07053.00164.10559.00556h2.508v1.8h-3.5l-.008-.9ZM6.67305,27.90781h-2.5c-.49398.05524-.9392-.30043-.99444-.79441-.00392-.03506-.00578-.07031-.00556-.10559v-.9h3.5v1.8ZM11.67305,27.90781h-4v-1.8h4v1.8ZM16.67305,27.90781h-4v-1.8h4v1.8ZM21.67305,27.90781h-4v-1.8h4v1.8ZM26.17305,27.00781c.00308.49705-.39736.90248-.89441.90556-.03527.00022-.07053-.00164-.10559-.00556h-2.5v-1.8h3.5v.9ZM26.17305,25.20781H3.17305v-10.8h22.992l.008,10.8ZM26.17305,13.50781h-3.5v-1.8h2.5c.49398-.05524.93921.30043.99444.79441.00392.03506.00578.07032.00556.10559v.9Z",
    strokeWidth: 0,
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.13879,9.91931c.51483,0,1.03015-.19647,1.42261-.58948l2.31671-2.31671v3.74799h4.02374v-3.59198l2.0838,2.11798c.39398.40033.9137.60077,1.43445.60077.50989,0,1.01978-.19257,1.41083-.5777.79285-.7796.80267-2.05341.02356-2.84576L16.32416.84406c-.00177-.00183-.00403-.00299-.0058-.00476-.09344-.09436-.19592-.17975-.30652-.25415-.01862-.01251-.03937-.01984-.05829-.03162-.09241-.05792-.18726-.11237-.28894-.15491-.03497-.01447-.07202-.02087-.1076-.03339-.12244-.04321-.24939-.07422-.38135-.09314-.09082-.013-.1817-.02704-.27338-.02759-.00415,0-.00793-.00122-.01208-.00122-.05994,0-.11633.01245-.17499.01764-.06915.00604-.13837.00769-.20673.02087-.01483.00287-.02942.00549-.04419.00873-.40771.06299-.80029.24573-1.11414.55994l-5.63397,5.63409c-.78601.78546-.78601,2.05975,0,2.84528.39252.39301.90778.58948,1.42261.58948Z",
    strokeWidth: 0,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.90582,10.76111h-9.00397v10.89014c0,1.11115-.89996,2.01208-2.01166,2.01208-1.11115,0-2.01208-.90094-2.01208-2.01208v-10.89014H4.1911c-1.06805-.05042-1.97772.76825-2.03967,1.83569v14.68591c.06195,1.06744.97162,1.88617,2.03967,1.83569h21.40875c1.06805.05048,1.97772-.76825,2.03973-1.83569v-14.68591c.02405-.98407-.74988-1.80353-1.73376-1.83569Z",
    strokeWidth: 0,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/ShareIcon.60a9cd82682b5177214422f4ac48380d.svg";
export { ForwardRef as ReactComponent };